export function useApi() {
  const apiPath = import.meta.env.VITE_API_PATH

  function api({
    url,
    method = 'GET',
    body,
    headers,
    callback,
    errorCallback = () => {}
  }) {
    const options = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        ...headers
      },
      body: body ? JSON.stringify(body) : undefined
    }

    fetch(`${apiPath}${url}`, options)
      .then(response => {
        if (!response.ok) throw new Error(response.statusText)

        return response.json()
      })
      .then(callback)
      .catch(errorCallback)
  }

  return { api }
}
